import { motion } from 'framer-motion'
import { useLanguage } from '../../../contexts/LanguageContext'
import MobileSlideShell from './MobileSlideShell'
import { fadeScaleProps, M_CARD } from './mobileMotion'

export default function Slide9M() {
  const { t } = useLanguage()
  const s = t.slides.slide9
  const points =
    Array.isArray(s.mobilePoints) && s.mobilePoints.length > 0
      ? s.mobilePoints
      : [s.body]

  return (
    <MobileSlideShell>
      <motion.p
        {...fadeScaleProps(0)}
        className="text-[13px] font-bold uppercase tracking-[0.2em] text-[#1B2A6B]/50"
      >
        {s.eyebrow}
      </motion.p>

      <motion.h2
        {...fadeScaleProps(0.06)}
        className="text-[26px] font-semibold leading-tight tracking-tight text-[#1B2A6B]"
      >
        {s.headline}
      </motion.h2>

      <div className="flex flex-col gap-3">
        {points.map((text, i) => (
          <motion.div
            key={i}
            {...fadeScaleProps(0.1 + i * 0.05)}
            className={`${M_CARD} flex gap-3`}
          >
            <span className="mt-1.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#22A756]/12 text-[13px] font-bold text-[#22A756]">
              {i + 1}
            </span>
            <p className="text-[16px] leading-relaxed text-[#1B2A6B]/75">{text}</p>
          </motion.div>
        ))}
      </div>

      {s.badge ? (
        <motion.p
          {...fadeScaleProps(0.1 + points.length * 0.05 + 0.06)}
          className="rounded-xl bg-[#22A756]/10 px-4 py-3 text-center text-[15px] font-medium leading-relaxed text-[#1B2A6B]"
        >
          {s.badge}
        </motion.p>
      ) : null}
    </MobileSlideShell>
  )
}
